import 'core-js/es/map';
import 'core-js/es/set';
import 'raf/polyfill';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import "./index.scss"

import { Amplify } from 'aws-amplify';
import config from 'config';

import LogRocket from 'logrocket';
LogRocket.init(process.env.REACT_APP_LOGROCKET_APPID);

Amplify.configure({
    Auth: {
        mandatorySignIn: false,
        region: config.cognito.REGION,
        userPoolId: config.cognito.USER_POOL_ID,
        identityPoolId: config.cognito.IDENTITY_POOL_ID,
        userPoolWebClientId: config.cognito.APP_CLIENT_ID,
        oauth: {
            domain: 'your_cognito_domain',
            scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
            redirectSignIn: 'http://localhost:3000/',
            redirectSignOut: 'https://login.microsoftonline.com/f66fae02-5d36-495b-bfe0-78a6ff9f8e6e/saml2',
            responseType: 'token' // or 'token', note that REFRESH token will only be generated when the responseType is code
        }
    },
    Storage: {
        region: config.s3.REGION,
        bucket: config.s3.BUCKET,
        identityPoolId: config.cognito.IDENTITY_POOL_ID
    },
    API: {
        endpoints: [
            {
                name: 'user',
                endpoint: config.apiGatewayUser.URL,
                region: config.apiGatewayUser.REGION
            },
            {
                name: 'dr',
                endpoint: config.apiGatewayDr.URL,
                region: config.apiGatewayDr.REGION
            }
        ]
    }
});
const rootEl = document.getElementById('root');
ReactDOM.render(
    <div style={{ fontFamily: "'Roboto', sans-serif" }}>
        <App />
    </div>,
    rootEl
);
